import cn from 'classnames'
import {Icon} from 'src/common/Icon'
import type {SwiperClass} from 'swiper/react'

type SwiperNavButtonsProps = {
  swiperInstance: SwiperClass | null
  enableReskin?: boolean
}

const SwiperNavButtons = ({swiperInstance, enableReskin = false}: SwiperNavButtonsProps) => (
  <div className="flex items-end gap-3">
    <button
      className={cn({
        'pointer-events-none text-grey-200': swiperInstance?.isBeginning && !enableReskin,
        'pointer-events-none': swiperInstance?.isBeginning && !enableReskin,
        'flex h-6 items-center focus:border-blue-550': !enableReskin,
        'flex h-8 w-8 items-center justify-center bg-green-neon rounded-[4px] hover:bg-green-neon/[80%]': enableReskin,
      })}
      onClick={() => swiperInstance?.slidePrev()}
    >
      <Icon
        className={cn('rotate-180', {
          'h-6 w-6': !enableReskin,
          'h-[11px] w-[11px] text-green-dark': enableReskin,
        })}
        name={enableReskin ? 'arrow' : 'right-arrow'}
      />
    </button>
    <button
      className={cn({
        'pointer-events-none text-grey-200': swiperInstance?.isEnd && !enableReskin,
        'pointer-events-none': swiperInstance?.isEnd && enableReskin,
        'flex h-6 items-center focus:border-blue-550': !enableReskin,
        'flex h-8 w-8 items-center justify-center bg-green-neon rounded-[4px] hover:bg-green-neon/[80%]': enableReskin,
      })}
      onClick={() => swiperInstance?.slideNext()}
    >
      <Icon
        className={cn({
          'h-6 w-6': !enableReskin,
          'h-[11px] w-[11px] text-green-dark': enableReskin,
        })}
        name={enableReskin ? 'arrow' : 'right-arrow'}
      />
    </button>
  </div>
)

export default SwiperNavButtons
